import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const email = searchParams.get('email') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('As senhas nao coincidem');
      return;
    }
    if (password.length < 8) {
      setError('A senha deve ter pelo menos 8 caracteres');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await api.post('/auth/reset-password/confirm', { token, newPassword: password });
      if (response.data.success) {
        setSuccess(true);
      } else {
        setError(response.data.error || 'Erro ao redefinir senha');
      }
    } catch (err: any) {
      setError(err.message || 'Erro ao processar pedido');
    } finally {
      setLoading(false);
    }
  };

  if (!token || !email) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-pagali-gray-50 px-4">
        <div className="text-center">
          <h2 className="text-xl font-bold text-red-600 mb-2">Link Invalido</h2>
          <p className="text-pagali-gray-600 mb-4">Este link de recuperacao e invalido ou expirou.</p>
          <Link to="/recover-password" className="text-pagali-primary hover:underline">Pedir novo link</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-pagali-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-pagali-primary">PAGALI</h1>
          <p className="text-pagali-gray-500 mt-2">Definir Nova Senha</p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8">
          {success ? (
            <div className="text-center">
              <div className="text-5xl mb-4">✅</div>
              <h2 className="text-xl font-bold text-pagali-gray-900 mb-2">Senha Alterada</h2>
              <p className="text-pagali-gray-600 mb-6">A sua senha foi redefinida com sucesso.</p>
              <Link to="/login" className="inline-block bg-pagali-primary text-white px-6 py-3 rounded-xl font-semibold hover:opacity-90">
                Ir para Login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl mb-4 text-sm">{error}</div>
              )}
              <div className="mb-4">
                <label className="block text-sm font-medium text-pagali-gray-700 mb-1">Nova Senha</label>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8}
                  className="w-full px-4 py-3 border border-pagali-gray-200 rounded-xl focus:ring-2 focus:ring-pagali-primary focus:border-transparent outline-none" />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-pagali-gray-700 mb-1">Confirmar Senha</label>
                <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={8}
                  className="w-full px-4 py-3 border border-pagali-gray-200 rounded-xl focus:ring-2 focus:ring-pagali-primary focus:border-transparent outline-none" />
              </div>
              <button type="submit" disabled={loading}
                className="w-full bg-pagali-primary text-white py-3 rounded-xl font-semibold hover:opacity-90 disabled:opacity-50">
                {loading ? 'A processar...' : 'Redefinir Senha'}
              </button>
              <div className="mt-4 text-center">
                <Link to="/login" className="text-sm text-pagali-primary hover:underline">Voltar ao Login</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
